export default __webpack_public_path__ + "static/N0194-3b7b4528bfc4d1c7f0698ca573a8f11e.png";